<script>
import arrUtil from "../../../utils/static/arrayUtil";
const TAG_ITEM = "urStepItem";

// ur-step-box는 ur-step-item의 모태가 되는 컴포넌트로,
// 설정에 따라 validation 체크 및 step 전환시 함수호출을 수행할 수 있습니다.
// #ur-step-box is a component of ur-step-item.
// #Depending on the setting, you can perform a function call during validation check and step switching.
export default {
    name : "urStepBox",
    data () {return {
        stateList : [], /*state : "D"one,"I"ng,"R"eady */ /* NOT_YET : "F"ail */
        currIdx : 0
    }},
    props : {
        // $ver: v0.2.0
        // Step box의 단계별 Label 값 들입니다. 배열 타입으로 정의해야합니다.
        // #A value representing the Steps Label List. You need to define Array type
        // $tags IDE, steps
        steps : Array,
        // $ver: v0.2.0
        // Step box의 단계별 Label 의 너비입니다.
        // #A value is for Step's width
        stepWidth : {type:[String,Number],default:160},
        // $ver: v0.2.0
        // Step box 의 높이 값을 100%로 설정합니다..
        // #A value sets stepbox's height to 100%
        fullHeight : Boolean,
        // $ver: v0.2.0
        // step box 마지막 단계의 버튼 Label 값입니다.
        // #A value representing last step's action label
        // $tags IDE, actionLabel
        actionLabel : [String,Number]
    },
    computed : {
        stepBroken() { return arrUtil.isEmpty(this.steps); },
        $_stepWidth() { return parseInt(this["step-width"]); }
    },
    created() {
        this.init();
    },
    methods : {
        init() {
            if( this.stepBroken ) return;
            // 1. build stat list
            this.stateList = this.steps.map(st => "R");
            // 2. set init idx
            this.currIdx = 0;
            this.stateList[this.currIdx] = "I";
        },
        setIdx(idx) {


            // 1. check valid
            let ci = this.currIdx;
            if( idx > ci ) { // move to forward
                // 1.1 current step
                let cstep = this.steps[ci];
                if( typeof cstep === "object" && !cstep.valid ) {
                    this.$emit('fail-valid');
                    return;
                }

                let fn = () => true;
                if( cstep && cstep.check && typeof cstep.check === 'function' ) fn = cstep.check;
                if( fn() !== true ) return;

                // 1.2 iter step
                for(let i = ci+1, ii = this.steps.length; i<ii && i<idx ; i++ ) {
                    let step = this.steps[i];
                    if( typeof step === "object" && !step.valid ) {
                        this.$emit('fail-valid');
                        idx=i;
                        break;
                    }
                }
            }
            // 2. set value
            // 2.1 set State List
            for(let i=0,ii=this.stateList.length; i<ii ; i++ ) {
                this.stateList[i] = i<idx?"D":"R";
            }
            this.stateList[idx] = "I";
            // 2.2 set Current Index
            this.currIdx = idx;
            // 3. re-draw
            this.$forceUpdate();
            this.$emit("moveStep",idx);
        },
        buildStepper() {
            let $ce = this.$createElement;
            let opt = {}, chs = [];
            // 0. check something
            if(this.stepBroken) {return this.buildEmptyStepper();}
            // 1. opt
            opt["class"] = "ur-step-box__stepper";
            opt["style"] = {"width":this.$_stepWidth+"px"};
            // 2. chs
            let steps = this.steps;
            for(let i=0,ii=steps.length; i<ii; i++) {
                if( i!==0 ) {
                    chs.push(this.buildStepperSpacing());
                }
                chs.push(this.buildStepperItem(i));
            }

            return $ce('div',opt,chs)
        },
        buildStepperSpacing() {
            let $ce = this.$createElement;
            return $ce('div',{"class":"ur-step-box__stepper__spacing"},"...");
        },
        buildStepperItem(idx) {
            // 0. prepare
            let $ce = this.$createElement, itemChs = [];
            let childOn = {"click":(e) => {
                this.setIdx(idx);
            }};
            // 1. item option
            let itemClazz = "ur-step-box__stepper__item "+itemClassByState(this.stateList[idx]);
            // 2. item stat(bubble)
            let statCont = null;
            switch(this.stateList[idx]) {
            case "D": statCont = $ce("ur-icon",{},["check"]);break;
            case "F": statCont = $ce("ur-icon",{},["close"]);break;
            default : statCont = $ce("span",{},[idx+1]);}
            itemChs.push($ce("div",{"class":"ur-step-box__stepper__item__stat","on":childOn}, [statCont]))
            // 3. stat label
            let step = this.steps[idx];
            let label = typeof step === "object" ? step.name : step;
            itemChs.push($ce("div",{"class":"ur-step-box__stepper__item__label line-break","on":childOn}, [label]))
            // x. return "STEPPER ITEM"

            return $ce("div",{"class":itemClazz},itemChs);
            // -. local function
            function itemClassByState(stat) {
                switch(stat) {
                    case "D":
                        return "ur-step-box__stepper__item--done";
                    case "F":
                        return "ur-step-box__stepper__item--fail";
                    case "I":
                        return "ur-step-box__stepper__item--ing";
                    case "R":
                        return "ur-step-box__stepper__item--ready";
                    default:
                        return "ur-step-box__stepper__item--fail";
                }
            }
        },
        buildEmptyStepper() {
            let $ce = this.$createElement;
            let EMPTY_MESSAGE = "Steps is not defined. Empty broken";
            let clazz = "ur-step-box__stepper ur-step-box__stepper--empty"
            return $ce('div',{"class":clazz},[EMPTY_MESSAGE])
        },
        buildContent() {
            // 0. prepare
            let defaultSlot = this.$slots["default"];
            let contents = [], idx = 0;
            // 1. Classify
            defaultSlot.forEach(vNode => {
                if(!vNode.componentOptions){ return; }
                let nodeName = vNode.componentOptions.Ctor.options.name;
                if( TAG_ITEM === nodeName ) {
                    contents.push(vNode);
                    let nodeFlag = idx===this.currIdx;
                    // set elm
                    this.$nextTick(()=>{
                        let $el = vNode.elm;
                        if(!$el) return;
                        $el.style.display = nodeFlag?"block":"none";
                    })
                    idx++;
                }
            })
            return contents;
        },
        buildActions(){
            let $ce = this.$createElement;
            let ci = this.currIdx,step = this.steps[ci];
            let valid = typeof step === "object" ? step.valid : true;
            let chs = [];
            if(this.$slots['custom-action']) {
                chs = chs.concat(...this.$slots['custom-action'])
            }
            // 1. add button
            // 1.1 previous step
            if(ci > 0 ) {
                let opt = {};
                opt.on = {"click":()=>{this.setIdx(ci-1);}};
                chs.push($ce("ur-button",opt,["Previous"]));
            }
            // 1.2 Next step
            if(ci < this.steps.length-1 ) {
                let opt = {};
                opt.on = {"click":()=>{this.setIdx(ci+1);}};
                opt.props = {"disabled":!valid}
                chs.push($ce("ur-button",opt,["Next"]));
            }
            // 1.3 last action
            if(ci === this.steps.length-1 ) {
                let opt = {};
                opt.props = {"primary":true,"solid":true};
                opt.on    = {click:()=>{this.$emit("action");}};
                chs.push($ce("ur-button",opt,this.actionLabel || "Action"));
            }
            return $ce("ur-action-bar",{},chs);
        }
    },
    render($ce) {
        // 1. opt
        let clazz = ["ur-step-box"];
        if(this.fullHeight) clazz.push("ur-step-box--full-height");

        // 2. chs
        let stepper = this.buildStepper();
        let content = this.buildContent();
        let actions = this.buildActions();
        let chs = [stepper].concat(content).concat(actions);

        return $ce('div',{"class":clazz},chs);
    }
}
</script>
